import React, { useEffect, useState } from 'react';
import { Modal } from '@mui/material';
import { Typography } from '@mui/material';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { format } from 'date-fns';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import { AdminHeader } from '../AdminHeader/AdminHeader';
import secureLocalStorage from 'react-secure-storage';
import AgentList from './AgentList';
import FetchLoading from './../../Loading/FetchLoading';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: '#fff',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const AgentManagement = () => {
  const [isLoading, setIsloading] = useState(false);
  const [allAgentData, setAllAgentData] = useState([]);
  const [agentData, setAgentData] = useState([]);
  const [details, setDetails] = useState({});
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [rowLoading, setRowLoading] = useState({});
  const [refetch, setRefetch] = useState(false);

  const handleClose = () => setOpen(false);
  // Sets the state of the const for the given page and state.
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(1);
  let size = 15;

  // Handle a page change.
  const handlePageChange = (event, value) => {
    setPage(value);
    setAllAgentData(allAgentData.slice((value - 1) * size, value * size));
  };
  const adminInfo = secureLocalStorage.getItem('admin-info');
  const token = adminInfo.token;
  useEffect(() => {
    setIsloading(true);
    fetch(`https://api-b2b.businesssolutions.ae/admin/agent`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        const count = data?.length;
        const pageNumber = Math.ceil(count / size);
        setPageCount(pageNumber);
        setAllAgentData(data);
        setAgentData(data);
        setIsloading(false); // Set loading to false on successful data fetch
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setIsloading(false); // Set loading to false in case of an error
      });
  }, [refetch]);

  const handleActive = async (data, status) => {
    const url = `https://api-b2b.businesssolutions.ae/admin/agent/${data?.uid}`;

    let body = JSON.stringify({
      email: data?.email,
      company: data?.company,
      status: status,
      password: '12345678',
      markuptype: data?.markuptype,
      markup: data?.markup,
    });

    try {
      setRowLoading((prevLoading) => ({
        ...prevLoading,
        [data.uid]: true,
      }));
      const response = await fetch(url, {
        method: 'PATCH', // Use PATCH method
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // Include the Authorization header with the bearer token
        },
        body: body,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: `Agent ${status} Successfully`,
        confirmButtonText: 'OK',
      }).then(function () {
        setRefetch(!refetch);
        setRowLoading((prevLoading) => ({
          ...prevLoading,
          [data.uid]: false,
        }));
      });
    } catch (error) {
      console.error('Error activating agent:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: error.message,
        confirmButtonText: 'OK',
      }).then(function () {
        setRowLoading((prevLoading) => ({
          ...prevLoading,
          [data.uid]: false,
        }));
      });
    }
  };

  return (
    <Box>
      <AdminHeader />
      <Typography
        variant="span"
        sx={{
          fontWeight: 400,
          fontSize: '24px',
          color: '#222222',
          mb: 1,
          p: 2,
        }}
      >
        Agent Management 
      </Typography>
      <Box p={2}>
        {!isLoading ? (
          <AgentList
            data={agentData}
            pageSize={15}
            refetch={refetch}
            setRefetch={setRefetch}
          />
        ) : (
          <FetchLoading />
        )}
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{ ...style, width: 600 }}
          style={{ border: 'none', borderRadius: '5px' }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ width: '100%' }}>
              {' '}
              <Typography
                sx={{ color: 'var(--secondary-color0', fontSize: '17px' }}
              >
                Agent ID:{details?.agentId} {}
              </Typography>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{
                  fontSize: '25px',
                  color: '#003566',
                  fontWeight: 500,
                }}
              ></Typography>
              <Typography
                id="modal-modal-description"
                sx={{
                  mt: 2,
                  width: '70%',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span sx={{ width: '40%' }}>Agent Name: </span>{' '}
                <span
                  style={{
                    width: '60%',
                    textAlign: 'left',
                    marginLeft: '10%',
                  }}
                >
                  {details?.name}
                </span>
              </Typography>
              <Typography
                id="modal-modal-description"
                sx={{
                  mt: 2,
                  width: '70%',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span style={{ width: '30%' }}>Email: </span>{' '}
                <span
                  style={{
                    width: '60%',
                    textAlign: 'left',
                    marginLeft: '10%',
                  }}
                >
                  {details?.email}
                </span>
              </Typography>
              <Typography
                id="modal-modal-description"
                sx={{
                  mt: 2,
                  width: '70%',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span sx={{ width: '40%' }}>Phone: </span>{' '}
                <span
                  style={{
                    width: '60%',
                    textAlign: 'left',
                  }}
                >
                  {details?.phone}
                </span>
              </Typography>
              <Typography
                id="modal-modal-description"
                sx={{
                  mt: 2,
                  width: '70%',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span sx={{ width: '40%' }}>Address: </span>{' '}
                <span
                  style={{
                    width: '60%',
                    textAlign: 'left',
                  }}
                >
                  {details?.address}
                </span>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default AgentManagement;
